import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "vant/lib/index.css";
import "@vant/touch-emulator";
import "./assets/style.css";
import { Capacitor } from "@capacitor/core";
import { App as CapApp } from "@capacitor/app";
import { setTokenExpiredHandler } from "@/api/lst";
import { clearTokenCheckCache } from "@/utils/lstTokenGate";
import { clearLstSession } from "@/utils/lstSessionStorage";
import { initDeviceSecurity } from "@/utils/appSecurity";
import { applyUiTheme } from "@/config";
import { initYstMobileBehaviors } from "@/utils/ystMobileBehaviors";
applyUiTheme();
initYstMobileBehaviors();
await initDeviceSecurity();
const app = createApp(App);
app.use(router);
setTokenExpiredHandler((msg) => {
    console.warn("Token\u8FC7\u671F\uFF0C\u81EA\u52A8\u8DF3\u8F6C\u767B\u5F55:", msg);
    clearTokenCheckCache();
    clearLstSession();
    if (router.currentRoute.value.path !== "/") {
        router.push("/");
    }
});
app.mount("#app");
if (Capacitor.isNativePlatform()) {
    CapApp.addListener("backButton", ({ canGoBack }) => {
        if (canGoBack)
            router.back();
        else
            CapApp.exitApp();
    });
}
